"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const es_cookie_1 = require("es-cookie");
class CookiesA {
    static getCookie(name) {
        return (0, es_cookie_1.get)(name);
    }
    static setCookie(name, value, expires, domain, path, secure, sameSite) {
        if (secure && sameSite === "none") {
            (0, es_cookie_1.set)(name, value, {
                domain: domain,
                expires: expires,
                path: path,
                sameSite: sameSite,
                secure: secure
            });
        }
        else if (sameSite === "lax" || sameSite === "strict") {
            (0, es_cookie_1.set)(name, value, {
                domain: domain,
                expires: expires,
                path: path,
                sameSite: sameSite,
                secure: secure
            });
        }
        else {
            (0, es_cookie_1.set)(name, value, {
                domain: domain,
                expires: expires,
                path: path,
                secure: secure
            });
        }
    }
    static getJSONCookie(name) {
        const cookie = (0, es_cookie_1.get)(name);
        try {
            return cookie && JSON.parse(cookie);
        }
        catch (error) {
            throw `cookie=${name} is not JSON formatted ${error}`;
        }
    }
    static setJSONCookie(name, value, expires, domain, path, secure, sameSite) {
        const jsonValue = JSON.stringify(value);
        CookiesA.setCookie(name, jsonValue, expires, domain, path, secure, sameSite);
    }
    static removeCookie(name, path, secure = window.location.protocol === "https:") {
        (0, es_cookie_1.remove)(name, { path, secure });
    }
}
exports.default = CookiesA;
//# sourceMappingURL=Cookies.js.map